var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRebateCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26.615,
    viewBox: "0 0 25 26.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rebate-companies",
    transform: "translate(-695 -691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1530085_building_business_city_commercial_company_icon",
    "data-name": "1530085_building_business_city_commercial_company_icon",
    transform: "translate(675.456 679.243)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 1.245,
    height: 2.293,
    transform: "translate(23.747 27.762)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 1.245,
    height: 2.292,
    transform: "translate(23.747 32.346)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 1.245,
    height: 2.292,
    transform: "translate(23.747 23.177)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 1.245,
    height: 2.292,
    transform: "translate(27.567 32.346)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 1.245,
    height: 2.293,
    transform: "translate(27.567 27.762)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 1.245,
    height: 2.292,
    transform: "translate(27.567 23.177)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 2.436,
    height: 1.245,
    transform: "translate(34.686 30.405)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 2.436,
    height: 1.245,
    transform: "translate(34.686 33.461)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M33.017,38.372h4.465a2.469,2.469,0,0,0,2.465-2.466V26.8H33.016V18.757H19.544V38.372H33.017ZM38.7,28.042v7.864a1.222,1.222,0,0,1-1.22,1.221H33.017V28.04ZM20.789,37.126V20H31.771V37.126H20.789Z",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(702 691)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "%",
    transform: "translate(705 705)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Lora-Regular, Lora"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRebateCompanies);
export default __webpack_public_path__ + "static/media/icon-rebate-companies.780f6eec962ca8c61b97cc8af37d7fbd.svg";
export { ForwardRef as ReactComponent };